export const ORDER_API_PATH = '/_api/payment-paybutton-web/paybutton/v2/orders';
